// O que a listagem de chamados tem a dizer enquanto ela mesma carrega.
//
// ## O defeito
//
// A tela não dava sinal nenhum de carregamento. Pior: com a lista ainda
// vazia, ela já afirmava "Nenhum ticket encontrado" -- a mesma frase que usa
// quando a busca realmente não achou nada. Quem abria um filtro grande lia
// "não há nada aqui" enquanto o servidor ainda estava respondendo, e isso é
// indistinguível de um filtro quebrado.
//
// O dado existia: `fetchTickets` já liga e desliga `state.tickets.loading` no
// redux desde sempre, e a tela simplesmente nunca o leu. O que faltava era
// dizer o que fazer com ele.
//
// ## A regra
//
// Carregando COM linhas na tela não troca o conteúdo: trocar a lista por um
// "carregando" a cada atualização faria a tela piscar e perderia a posição de
// quem estava lendo. Nesse caso o aviso é só a barra fina no topo.
//
// Carregando SEM linha nenhuma é o caso que enganava, e aí o texto muda.

export const CARREGANDO = 'carregando';
export const VAZIO = 'vazio';
export const COM_LINHAS = 'com-linhas';

/** O que mostrar no lugar da lista enquanto ela não chegou. */
export const TEXTO_CARREGANDO = 'Carregando chamados...';

/**
 * @param {object} entrada
 * @param {boolean} entrada.carregando há requisição de lista em andamento
 * @param {number} entrada.quantidade quantas linhas já estão na tela
 * @returns {string} CARREGANDO, VAZIO ou COM_LINHAS
 */
export function estadoDaListagem({ carregando, quantidade } = {}) {
    const linhas = Number(quantidade);
    const temLinha = Number.isFinite(linhas) && linhas > 0;

    if (temLinha) return COM_LINHAS;

    return carregando ? CARREGANDO : VAZIO;
}

export default estadoDaListagem;
